var map = {
	"./pr-1.png": "4088",
	"./pr-10.png": "8a43",
	"./pr-11.png": "0d65",
	"./pr-2.png": "00b7",
	"./pr-3.png": "25a6",
	"./pr-4.png": "8553",
	"./pr-5.png": "7ccd",
	"./pr-6.png": "71a2",
	"./pr-7.png": "8c7a",
	"./pr-8.png": "40d2",
	"./pr-9.png": "5ade"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32e3";